import React from "react";
import { DatePicker, Label, TimePicker } from "@src/common/components";
import {
  dateToTimeString,
  timeStringToDate,
} from "@src/common/utils/timezoneConverters";

interface CompletionOverrideDateTimeFieldsProps {
  date: Date | null;
  time: Date | null;
  onDateChange: (date: Date | null) => void;
  onTimeChange: (time: Date | null) => void;
  disabled?: boolean;
}

function CompletionOverrideDateTimeFields({
  date,
  time,
  onDateChange,
  onTimeChange,
  disabled = false,
}: CompletionOverrideDateTimeFieldsProps) {
  const isPartiallyFilled: boolean = !!date !== !!time;

  return (
    <div className="flex flex-col mb-4">
      <p>Override completed date &amp; time (optional)</p>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col">
          <Label>Date</Label>
          <DatePicker
            value={date}
            disabled={disabled}
            onChange={({ date: selectedDate }) => {
              onDateChange(
                Array.isArray(selectedDate)
                  ? selectedDate[0] ?? null
                  : selectedDate ?? null
              );
            }}
          />
        </div>
        <div className="flex flex-col">
          <Label>Time</Label>
          <TimePicker
            nullable
            disabled={disabled}
            value={dateToTimeString(time)}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              onTimeChange(
                event.target.value === ""
                  ? null
                  : timeStringToDate(event.target.value)
              );
            }}
          />
        </div>
      </div>
      {isPartiallyFilled && (
        <p className="mt-1 text-sm text-gray-500">
          Set both date and time to override the completion time; otherwise the
          actual completion times are used.
        </p>
      )}
    </div>
  );
}

export { CompletionOverrideDateTimeFields };
export type { CompletionOverrideDateTimeFieldsProps };
